var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLogin", { attrs: { title: "GeoVisor" } }, [
    !_vm.checkChrome
      ? _c("div", { staticClass: "text-center mb-3" }, [
          _c("h4", { staticStyle: { color: "#c01313" } }, [
            _vm._v("Su navegador no es compatible con GeoVisor.")
          ]),
          _vm._v(" "),
          _c("h4", { staticStyle: { color: "#c01313" } }, [
            _c("b", [_vm._v("Utilice Chrome")]),
            _vm._v(" para acceder a la aplicación")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          [
            !_vm.useEntraInsteadOfUsrAndPwd
              ? _c(
                  "div",
                  [
                    _c(
                      "b-form-group",
                      {
                        class: {
                          feedback: _vm.errors.has("Código de usuario")
                        },
                        attrs: {
                          label: "Código de usuario:",
                          "label-for": "Código de usuario"
                        }
                      },
                      [
                        _c("b-form-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            type: _vm.type,
                            name: "Código de usuario",
                            id: "Código de usuario"
                          },
                          model: {
                            value: _vm.value_field,
                            callback: function($$v) {
                              _vm.value_field = $$v
                            },
                            expression: "value_field"
                          }
                        }),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-down" } }, [
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("Código de usuario"),
                                  expression: "errors.has('Código de usuario')"
                                }
                              ],
                              staticClass: "alert alert-danger feedback-message"
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.errors.first("Código de usuario")
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        class: { feedback: _vm.errors.has("contraseña") },
                        attrs: {
                          label: "Contraseña:",
                          "label-for": "contraseña"
                        }
                      },
                      [
                        _c("b-form-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "password",
                            name: "contraseña",
                            id: "pwd"
                          },
                          model: {
                            value: _vm.password,
                            callback: function($$v) {
                              _vm.password = $$v
                            },
                            expression: "password"
                          }
                        }),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-down" } }, [
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("contraseña"),
                                  expression: "errors.has('contraseña')"
                                }
                              ],
                              staticClass: "alert alert-danger feedback-message"
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.errors.first("contraseña")) +
                                  "\n          "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-down" } }, [
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("bot"),
                                  expression: "errors.has('bot')"
                                }
                              ],
                              staticClass: "alert alert-danger feedback-message"
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.errors.first("bot")) +
                                  "\n          "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", [
                  _c(
                    "div",
                    [
                      !_vm.logged
                        ? _c("Recaptcha", { on: { validate: _vm.validate } })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "mt-3" },
              [
                !_vm.useEntraInsteadOfUsrAndPwd
                  ? [
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                block: "",
                                disabled: !this.validateRecaptcha,
                                id: "login-button",
                                variant: "primary"
                              },
                              on: { click: _vm.login }
                            },
                            [
                              _vm._v("\n            Entrar "),
                              this.validateRecaptcha
                                ? _c("i", { staticClass: "fa fa-sign-in" })
                                : _vm._e(),
                              !this.validateRecaptcha
                                ? _c("i", { staticClass: "fa fa-lock" })
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-right", attrs: { lg: "8" } },
                        [
                          _vm.manageUs === true
                            ? _c(
                                "b-link",
                                { on: { click: _vm.resetPassword } },
                                [_vm._v("¿Has olvidado la contraseña?")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  : [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                block: "",
                                disabled: !this.validateRecaptcha,
                                id: "signInEntra-button",
                                variant: "primary"
                              },
                              on: { click: _vm.signIn }
                            },
                            [
                              _vm._v("\n            Entrar con Microsoft"),
                              this.validateRecaptcha
                                ? _c("i", { staticClass: "fa fa-sign-in" })
                                : _vm._e(),
                              !this.validateRecaptcha
                                ? _c("i", { staticClass: "fa fa-lock" })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "slide-down" } }, [
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("bot"),
                                    expression: "errors.has('bot')"
                                  }
                                ],
                                staticClass:
                                  "alert alert-danger feedback-message"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("bot")) +
                                    "\n            "
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ]
              ],
              2
            )
          ],
          1
        )
      : _c("div", { staticClass: "card-body text-center" }, [
          _c("p", [_c("i", { staticClass: "fa fa-spinner fa-spin fa-3x" })]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("labels.loading")))])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Login/Login.vue?vue&type=template&id=4ffde338&
// module id = null
// module chunks = 